define('views/layout/header',['require','backbone','marionette','text!templates/layout/header.html'],function(require){
    var Backbone = require('backbone');
    require('marionette');

    var temp = require("text!templates/layout/header.html");

    return Backbone.Marionette.LayoutView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'header',

        initialize: function(options) {
            this.listenTo(App.vent, 'login-status-changed', this.render);
            this.listenTo(App.vent, 'page-title-changed', this.render);
        },

        ui: function() {
            return {
                pageTitle: '.page-title',
                logoutButton: '.logout-item',
                sidebarToggle: '.sidebar-toggle',
                languageButton: '.language-list li img'
            };
        },

        events: {
            'click @ui.logoutButton': 'logoutButtonClicked',
            'click @ui.sidebarToggle': 'sidebarToggleClicked',
            'click @ui.languageButton': 'languageButtonClicked'
        },

        logoutButtonClicked: function () {
          App.context.logout();
        },

        sidebarToggleClicked: function () {
            App.vent.trigger('sidebar-toggle-clicked');
        },

        languageButtonClicked: function (e) {
            var languageCode = $(e.currentTarget).attr('data-language');

            if (languageCode != App.context.locale) {
                // Clear constants value so that they will be re-fetched with chosen locale on page refresh
                localStorage.removeItem('constants');

                // Set locale cookie and refresh
                document.cookie = 'locale=' + languageCode;
                window.location.reload();
            }
        }

    });
});
